module.exports = __webpack_public_path__ + "static/media/icon-sort-inactive.c587a129.svg";